import React, { useState } from 'react';
import {
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
  Container,
} from '@mui/material';

import {
  Business,
  Phone,
} from '@mui/icons-material';

import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import HomeIcon from '@mui/icons-material/Home';
import { GetGreenHouseDataAPI, SetGreenhouseCreate, SetGreenhouseEdit } from '../../Conections/GreenhouseConection';

const GreenhouseEdit = () => {

  const goTo = useNavigate();
  const { getToken, getCompany } = useAuth();
  const { id } = useParams();

  const [greenhouse, setGreenhouse] = useState({
    name: '',
    address: '',
    phone: ''
  });

  const [errors, setErrors] = useState({});

  React.useEffect(() => {
    reloaduser();
  }, []);

  async function reloaduser() {
    if (getToken()) {
      const permisionCan = await can(getToken(), getCompany(), "/greenhouse/creategreenhouse");
      if (permisionCan === 1) {
        let GreenhouseIn = await GetGreenHouseDataAPI(getToken(), getCompany(), id);
        setGreenhouse(GreenhouseIn);
      }
      else {
        goTo("/dashboard");
      }
    }
    else {
      goTo(`/login`);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGreenhouse(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!greenhouse.name.trim()) {
      newErrors.nombre = 'El nombre es requerido';
    }
    if (!greenhouse.address.trim()) {
      newErrors.descripcion = 'La descripción es requerida';
    }
    if (!greenhouse.phone.trim()) {
      newErrors.descripcion = 'La descripción es requerida';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      const datos = await SetGreenhouseEdit(
        getToken(),
        getCompany(),
        id,
        greenhouse.name.trim(),
        greenhouse.address.trim(),
        greenhouse.phone.trim()
      );
      goTo(`/greenhouse/showgreenhouse/${datos}`);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          Editar Invernadero
        </Typography>
        <Card>
          <CardContent>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Nombre del Invernadero"
                name="name"
                value={greenhouse.name}
                onChange={handleChange}
                InputProps={{
                  startAdornment: <Business sx={{ mr: 1, color: 'action.active' }} />,
                }}
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre}
              />
              <TextField
                fullWidth
                label="Dirección"
                name="address"
                value={greenhouse.address}
                onChange={handleChange}
                required
                InputProps={{
                  startAdornment: <HomeIcon sx={{ mr: 1, color: 'action.active' }} />,
                }}
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre}
              />
              <TextField
                fullWidth
                label="Teléfono"
                name="phone"
                value={greenhouse.phone}
                onChange={handleChange}
                required
                InputProps={{
                  startAdornment: <Phone sx={{ mr: 1, color: 'action.active' }} />,
                }}
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre}
              />

              <Box sx={{ mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                >
                  Editar Invernadero
                </Button>
              </Box>
            </form>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default GreenhouseEdit;